
import { Component, Prop, Vue } from "vue-property-decorator";
import { marked } from "marked";

@Component
export default class AboutComponent extends Vue {
  @Prop()
  value!: boolean;
  changelog: string = "Changelog not loaded yet...";

  mounted() {
    let req = new XMLHttpRequest();
    req.onloadend = () => {
      if (req.status === 200) {
        this.changelog = req.responseText;
      } else {
        this.changelog = "Changelog failed to load, sorry.";
      }
    }
    req.open("GET", "CHANGELOG.md");
    req.send();
  }

  get changelogToHtml() {
    let page = marked.parse(this.changelog.replace("git.steumatt.goip.de", "steumatt.goip.de/git"));
    return page;
  }

  get show(): boolean {
    return this.value
  }
  set show(value: boolean) {
    this.$emit('input', value)
  }

  get name() {
    return process.env.VUE_APP_NAME
  }
  get version() {
    return process.env.VUE_APP_VERSION
  }

  close() {
    this.show = false;
  }
}
